/**
 * The loot window's words (P2.8-T16, ADR-091 decisions 19 and 22): the design's where the `loot` card in
 * `ItemSurfaces.jsx` has them ("Chest", "Take", "Take all", "Taking", "Nothing left to take.", "You have already
 * looted this.", "Your bags are full."), ADR-091's for a chest that cannot be read, and drafts for the author for
 * what neither has: the other refusals' sentences and the rows' accessible names. A loot toast names the item alone,
 * with no line saying where it came from (the author's ruling of 2026-10-09). `{take}` is the Take button's word,
 * `{item}` an item as a bag slot names it, and `{quantity}` a count as the page prints it.
 */
export const CHEST = {
  title: "Chest",
  take: "Take",
  takeAll: "Take all",
  taking: "Taking",
  rows: "Chest contents",
  empty: "Nothing left to take.",
  looted: "You have already looted this.",
  lines: {
    cannotOpen: "The chest cannot be opened right now.",
    full: "Your bags are full.",
    reach: "You are too far from the chest.",
    closed: "Open the chest again to take from it.",
    busy: "The chest is busy. Try again in a moment.",
    unavailable: "That could not be taken. Try again.",
    taken: "You have already taken that.",
  },
  takeItem: "{take} {item}",
  takeFull: "{what}: your bags are full",
  stack: "{name} x{quantity}",
} as const;
